var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { ethers } from 'ethers';
import { API_ENDPOINT, API_ENDPOINT_DEV } from './config/endpoint';
import { BaseFacet__factory } from './typechain-types/factories/diamond';
import { DropFacet__factory } from './typechain-types/factories/apps/drop';
import { EditionFacet__factory } from './typechain-types/factories/apps/edition';
import { ApeDropFacet__factory } from './typechain-types/factories/apps/ape';
import { ERC20AppFacet__factory } from './typechain-types/factories/apps/erc20';
var Diamond = /** @class */ (function () {
    function Diamond(collectionId, signerOrProvider, isDev) {
        if (!collectionId) {
            throw new Error('No Collection ID.');
        }
        this.collectionId = collectionId;
        this.signerOrProvider = signerOrProvider;
        this.isDev = isDev;
        this.apps = {};
    }
    Diamond.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Diamond.getCollectionData(this.collectionId, this.isDev)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, this.initWithData(data)];
                }
            });
        });
    };
    Diamond.prototype.initWithData = function (data) {
        this.data = data;
        if (!this.data || !this.data.collectionId)
            throw new Error('Collection is not ready yet.');
        if (!this.data.address)
            throw new Error('Smart contract is not deployed yet.');
        this.chainId = this.data.chainId;
        this.networkName = this.data.networkName;
        this.base = BaseFacet__factory.connect(this.data.address, this.signerOrProvider);
        for (var _i = 0, _a = this.data.apps; _i < _a.length; _i++) {
            var app = _a[_i];
            if (app.id === ethers.utils.id('drop')) {
                this.apps.drop = DropFacet__factory.connect(this.data.address, this.signerOrProvider);
            }
            if (app.id === ethers.utils.id('edition')) {
                this.apps.edition = EditionFacet__factory.connect(this.data.address, this.signerOrProvider);
            }
            if (app.id === ethers.utils.id('ape')) {
                this.apps.ape = ApeDropFacet__factory.connect(this.data.address, this.signerOrProvider);
            }
            if (app.id === ethers.utils.id('erc20')) {
                this.apps.erc20 = ERC20AppFacet__factory.connect(this.data.address, this.signerOrProvider);
            }
        }
    };
    Diamond.prototype.verify = function (wallet) {
        return Diamond.verifyWallet(this.collectionId, wallet, this.isDev);
    };
    Diamond.prototype.verifyForEdition = function (wallet, editionId) {
        return Diamond.verifyWalletForEdition(this.collectionId, wallet, editionId, this.isDev);
    };
    Diamond.create = function (signerOrProvider, key, data, isDev) {
        return __awaiter(this, void 0, void 0, function () {
            var instance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        instance = new Diamond(key, signerOrProvider, isDev);
                        if (!data) return [3 /*break*/, 1];
                        instance.initWithData(data);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, instance.init()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, instance];
                }
            });
        });
    };
    Diamond.verifyWallet = function (collectionId, wallet, isDev) {
        return __awaiter(this, void 0, void 0, function () {
            var baseUrl, url, resp, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        baseUrl = isDev ? API_ENDPOINT_DEV : API_ENDPOINT;
                        url = "".concat(baseUrl, "/v3/collections/list/").concat(collectionId);
                        return [4 /*yield*/, axios.post(url, {
                                wallet: wallet,
                            }, {
                                validateStatus: function (status) { return status < 500; },
                            })];
                    case 1:
                        resp = _a.sent();
                        if (resp.status >= 400) {
                            message = resp.data.message;
                            throw new Error(message);
                        }
                        return [2 /*return*/, resp.data];
                }
            });
        });
    };
    Diamond.verifyWalletForEdition = function (collectionId, wallet, editionId, isDev) {
        return __awaiter(this, void 0, void 0, function () {
            var baseUrl, url, resp, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        baseUrl = isDev ? API_ENDPOINT_DEV : API_ENDPOINT;
                        url = "".concat(baseUrl, "/v3/editions/list/").concat(collectionId, "/").concat(editionId);
                        return [4 /*yield*/, axios.post(url, {
                                wallet: wallet,
                            }, {
                                validateStatus: function (status) { return status < 500; },
                            })];
                    case 1:
                        resp = _a.sent();
                        if (resp.status >= 400) {
                            message = resp.data.message;
                            throw new Error(message);
                        }
                        return [2 /*return*/, resp.data];
                }
            });
        });
    };
    Diamond.getCollectionData = function (collectionId, isDev) {
        return __awaiter(this, void 0, void 0, function () {
            var baseUrl, url, resp, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        baseUrl = isDev ? API_ENDPOINT_DEV : API_ENDPOINT;
                        url = "".concat(baseUrl, "/v3/collections/").concat(collectionId, "/address");
                        return [4 /*yield*/, axios.get(url, {
                                validateStatus: function (status) { return status < 500; },
                            })];
                    case 1:
                        resp = _a.sent();
                        if (resp.status >= 400) {
                            message = resp.data.message;
                            throw new Error(message);
                        }
                        return [2 /*return*/, resp.data];
                }
            });
        });
    };
    Diamond.getMintLinkByPublicKey = function (collectionId, publicKey, isDev, unique, quantity) {
        return __awaiter(this, void 0, void 0, function () {
            var baseUrl, url, resp, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        baseUrl = isDev ? API_ENDPOINT_DEV : API_ENDPOINT;
                        url = "".concat(baseUrl, "/onboarding/mintLinks/public/").concat(publicKey, "/").concat(collectionId, "?unique=").concat(unique, "&quantity=").concat(quantity);
                        return [4 /*yield*/, axios.get(url, {
                                validateStatus: function (status) { return status < 500; },
                            })];
                    case 1:
                        resp = _a.sent();
                        if (resp.status >= 400) {
                            message = resp.data.message;
                            throw new Error(message);
                        }
                        return [2 /*return*/, resp.data];
                }
            });
        });
    };
    return Diamond;
}());
export default Diamond;
